<adapt-universal-dashboard-element *adaptLoadingUntilFirstEmit="let team of team$"
                                   name="Accountabilities"
                                   [disableClick]="((canEditTeamAccountabilities$ | async) === false)"
                                   (headerClicked)="editTeamAccountabilities()"
                                   linkText="Define the accountabilities for the {{team?.teamTypeName?.toLocaleLowerCase()}}"
                                   [contentCard]="isAlto">
    <div *adaptLoadingUntilFirstEmit="let teamSupplementaryData of teamSupplementaryData$">
        @if (teamSupplementaryData && teamSupplementaryData?.accountabilities) {
            <div [froalaView]="teamSupplementaryData.accountabilities"></div>
        } @else {
            <adapt-call-to-action-inline>
                <p>Define the outcomes this {{team?.teamTypeName?.toLocaleLowerCase()}} is accountable for.</p>
                @if (!isAlto && !embedded) {
                    <button adaptCallToActionButton
                            adaptButtonIcon="edit"
                            *adaptIfAuthorised="ConfigureTeam;Entity:team$ | async"
                            (click)="editTeamAccountabilities()">
                        Define the {{team?.teamTypeName?.toLocaleLowerCase()}} accountabilities
                    </button>
                }
            </adapt-call-to-action-inline>
        }
    </div>
</adapt-universal-dashboard-element>
